import { defaultFont } from "../../../assets/jss/dibots-global-style";

import tooltip from "../../../assets/jss/toottips-style";

const headerLinksStyle = theme => ({
    list: {
        ...defaultFont,
        fontSize: "18px",
        marginRight: "0px",
        paddingLeft: "0px",
        listStyle: "none",
        paddingTop: "0",
        paddingBottom: "0",
        color: "inherit",
        paddingRight: "70px",
        // float: "right"
    },
    listItem: {
        float: "right",
        color: "inherit",
        position: "relative",
        display: "block",
        width: "auto",
        margin: "auto",
        padding: "0",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            "&:after": {
                width: "calc(100% - 30px)",
                content: '""',
                display: "block",
                height: "1px",
                marginLeft: "15px",
                backgroundColor: "#e5e5e5"
            },
            "&:last-child:after": {
                width: "100%",
                background: "rgba(0, 0, 0, 0.5)"
            }
        }
    },
    listItem2: {
        float: "right",
        color: "inherit",
        position: "relative",
        width: "auto",
        margin: "auto",
        padding: "0",
        [theme.breakpoints.down("sm")]: {
            width: "100%",
            "&:after": {
                width: "calc(100% - 30px)",
                content: '""',
                display: "block",
                height: "1px",
                marginLeft: "15px",
                backgroundColor: "#e5e5e5"
            },
            "&:last-child:after": {
                width: "100%",
                background: "rgba(0, 0, 0, 0.5)"
            }
        }
    },
    listItemText: {
        padding: "0 !important"
    },
    navLink: {
        color: "black",
        position: "relative",
        padding: "0.9375rem",
        fontWeight: "400",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        lineHeight: "20px",
        textDecoration: "none",
        margin: "3px",
        display: "inline-flex",
        "&:hover,&:focus": {
            color: "#fff",
            background: "#173862"
        },
        [theme.breakpoints.down("sm")]: {
            width: "calc(100% - 30px)",
            marginLeft: "15px",
            marginBottom: "8px",
            marginTop: "8px",
            textAlign: "left",
            "& > span:first-child": {
                justifyContent: "flex-start"
            }
        }
    },
    notificationNavLink: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "400",
        fontSize: "12px",
        textTransform: "uppercase",
        lineHeight: "20px",
        textDecoration: "none",
        margin: "0px",
        display: "inline-flex",
        top: "4px"
    },
    registerNavLink: {
        top: "3px",
        position: "relative",
        fontWeight: "400",
        fontSize: "12px",
        textTransform: "uppercase",
        lineHeight: "20px",
        textDecoration: "none",
        margin: "0px",
        display: "inline-flex"
    },
    navLinkActive: {
        color: "inherit",
        backgroundColor: "rgba(255, 255, 255, 0.1)"
    },
    icons: {
        width: "20px",
        height: "20px",
        marginRight: "3px"
    },
    socialIcons: {
        position: "relative",
        fontSize: "20px !important",
        marginRight: "4px"
    },
    dropdownLink: {
        "&,&:hover,&:focus": {
            color: "inherit",
            textDecoration: "none",
            display: "block",
            padding: "10px 20px"
        }
    },
    ...tooltip,
    marginRight5: {
        marginRight: "5px"
    },
    freetrial: {
        width: "18px",
        marginRight: "5px"
    },
    menuContainer: {
        position: "relative", 
        marginLeft: "-189px",
        "& div#simplepopover": {
            top: "20px !important"
        }
    },
    menuContainer2: {
        position: "relative",
        marginLeft: "-144px",
        "& div#simplepopover": {
            top: "30px !important"
        }
    },
    menuList: {
        // background: "white",
        // color: "black",
        // background: "#003663",
        // color: "white",
        // "& .MuiListItem-button:hover": {
        //     background: "rgba(255, 255, 255, 0.1)"
        // }
        background: "white",
        color: "black",
        "& .MuiListItem-button:hover": {
            background: "rgba(0, 0, 0, 0.1)"
        }
    },
    menuDivider: {
        width: "85%",
        margin: "4px auto",
        // background: "rgba(0, 0, 0, 0.5)",
        // background: "rgba(255, 255, 255, 0.5)"
        background: "rgba(0, 0, 0, 0.5)",
    },
    iconImage: {
        // marginRight: "6px",
        // filter: 'contrast(0) brightness(0) invert(1)',
        filter: 'contrast(1) brightness(1) invert(1)',
        width: "20px",
        height: "20px",
        marginRight: "3px"
    }


});

export default headerLinksStyle;
